import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const EventStatusPending = (props) => (<Svg {...props}>
    <Path d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm0 12A5.333 5.333 0 1 1 8 2.668a5.333 5.333 0 0 1 0 10.665Z" fill="#8F95B2"/>
  </Svg>);
export default EventStatusPending;
